import { Language, type Locale, Market, Stage } from '@sccs/types';

import { getMarketId, MARKETS_ISO_TO_PLAIN, MARKETS_TO_LANG, PROD_DOMAINS } from './Markets';

const urlLanguageEqualsMarketIdLocales: Locale[] = [
  { market: Market.CN, language: Language.zh },
  { market: Market.HK, language: Language.zh },
  { market: Market.BE, language: Language.nl },
];

export const getEmhSearchResultsUrl = (environment: Stage, locale: Locale, isVans: boolean): string | undefined => {
  const path =
    isVans && locale.market === Market.GB
      ? 'vans/buy/new-vans/search-results'
      : 'passengercars/buy/new-car/search-results';

  return getLanguageDependingUrl(environment, locale, path);
};

export const getLanguageDependingUrl = (environment: Stage, locale: Locale, path: string): string | undefined => {
  if (environment && locale && locale.language && locale.market && path) {
    const domain = getDomain(environment, locale.market);
    const languageDependingPath = getLanguageDependingPath(locale, path);

    return domain ? `https://${domain}/${languageDependingPath}` : undefined;
  }
};

export const getLanguageDependingPath = (locale: Locale, path: string): string => {
  const urlLanguage = getUrlLanguage(locale);
  if (urlLanguage && MARKETS_TO_LANG[locale.market]?.length > 1) {
    return `${urlLanguage}/${path}`;
  }
  return `${path}`;
};

const getUrlLanguage = (locale: Locale): string => {
  if (locale.market === Market.MO && locale.language === Language.zh) {
    return 'zh_HK';
  }
  if (
    urlLanguageEqualsMarketIdLocales.some(
      (specialLocale) => specialLocale.market === locale.market && specialLocale.language === locale.language,
    )
  ) {
    return getMarketId(locale);
  }
  return locale.language;
};

const getDomain = (environment: Stage, country: Market): string | undefined => {
  const countryName = MARKETS_ISO_TO_PLAIN[country];

  if (!countryName) {
    return undefined;
  }

  const environmentName = environment.toLocaleLowerCase();
  switch (environment) {
    case 'PROD':
      return getProdDomain(country);
    case 'INT':
    case 'PPROD':
    case 'TEST':
      return `${countryName}.${environmentName}-publish.mbmxp.aem.oneweb.mercedes-benz.com`;
    default:
      return undefined;
  }
};

const getProdDomain = (country: Market): string => {
  return PROD_DOMAINS.get(country) || 'www.mercedes-benz.com';
};
